export function copyToClipboard(data) {
  if (!navigator.clipboard) {
    return new Promise((res, rej) => {
      const result = fallbackCopyTextToClipboard(data);
      if (result === true) res(true);else rej(result);
    });
  } else {
    return modernTextToClipboard(data);
  }
}
function modernTextToClipboard(text) {
  return navigator.clipboard.writeText(text).then();
}
function fallbackCopyTextToClipboard(text) {
  const textArea = this.document.createElement("textarea");
  textArea.value = text;
  // Avoid scrolling to bottom
  textArea.style.top = "0";
  textArea.style.left = "0";
  textArea.style.position = "fixed";
  this.document.body.appendChild(textArea);
  textArea.focus();
  textArea.select();
  try {
    // eslint-disable-next-line deprecation/deprecation
    const successful = document.execCommand('copy');
    const msg = successful ? 'successful' : 'unsuccessful';
    console.log('Fallback: Copying text command was ' + msg);
  } catch (err) {
    return 'Fallback: Oops, unable to copy';
  }
  this.document.body.removeChild(textArea);
  return true;
}